import GenerateHtml from "./business-own-generate-html";
// import StartUpMainApp from "../main-start-up-screen/start-up";
import businessPageEditor from "../business-page-editor/business-page-editor";
import firebase from "../firebase";
import handleAccount from "../register/handle-account";
import register from "../register/register";
import businessPageEditor from "../business-page-editor/business-page-editor";
import AllDisplaysInitial from "../handeling-all-displays/all-handeling";
import GENRALHELPERS from "../GENRAL-HELPERS";
import createListing from "../create-listing/create-listing";
import accountProfileChange from "../main-menu/account-profile-change";
import nav from "../home-screen/nav";
import allHandeling from "../handeling-all-displays/all-handeling";
import displayListing from "../display-listing/generate-html";
import NVBusinessEditor from "../business-page-editor/NV-business-editor";
import spinner from "../spinner";
import generateHtmlListings from "../display-listing/generate-html";
import generateHtml from "../display-listing/generate-html";
import signUpProfile from "../sign-up_profile/signUpProfile";

class BusinessOwn {
  #currentAccount;
  #currentBsiness;
  #windowEventActivated = false
  #currentActi = 'businesses'
  #currentBusinessId = ''
  #draftsEventsActivated = false

  constructor() {
    // this._handelEditOptinsShow(true)
    this._handelEditOptinsEvents()
    this._initEditOptionsDrag();

  }
  _displayRightNavWindow() {
    const windows = document.querySelectorAll(
      ".MainAppConWithNavigationContentCon"
    );

    windows.forEach((window) => {
      if (window.id === "MainAppConWithNavigationContentConBusiness") {
        window.style.display = "";
      } else {
        window.style.display = "none";
      }
    });
  }
  _clearContainer() {
    const HomeScreenContenConForAll = document.getElementById(
      "MainAppConWithNavigationContentConBusiness"
    );
    HomeScreenContenConForAll.style.paddingTop = "0px";
    HomeScreenContenConForAll.innerHTML = "";
  }
  async _init(tab = 'businesses') {
    await firebase._getUserDataFromBase()

    this._displayRightNavWindow();
    this._NVPreparePage(tab)
    this._selectActiDisplay(tab)
    this._handleUploadButtons()
  }


  // call this to show/hide the sheet
  _handelEditOptinsShow(open) {
    const NVEditOptions = document.getElementById('NVEditOptions');
    if (!NVEditOptions) return;
    const sheet = NVEditOptions.querySelector('.nvEditOptionsCon1');
    if (!sheet) return;

    // Ensure transition style is set once
    sheet.style.transition = 'transform 0.35s ease, opacity 0.35s ease';

    if (open) {
      // Make container visible first
      NVEditOptions.style.display = 'flex';
      NVEditOptions.style.pointerEvents = 'auto';
      sheet.style.pointerEvents = 'auto';

      // Start from off-screen
      sheet.style.transform = 'translateY(100%)';
      sheet.style.opacity = '0';

      // Animate in on the next frame
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          sheet.style.transform = 'translateY(0)';
          sheet.style.opacity = '1';
        });
      });
    } else {
      // Animate out
      sheet.style.transform = 'translateY(100%)';
      sheet.style.opacity = '0';
      sheet.style.pointerEvents = 'none';
      NVEditOptions.style.pointerEvents = 'none';

      // After transition, hide completely
      const cleanup = () => {
        NVEditOptions.style.display = 'none';
        sheet.removeEventListener('transitionend', cleanup);
      };

      sheet.addEventListener('transitionend', cleanup);

      // Fallback timeout in case transitionend doesn’t fire
      setTimeout(cleanup, 350);
    }
  }

  _initEditOptionsDrag() {
    const NVEditOptions = document.getElementById('NVEditOptions');
    if (!NVEditOptions) return;
    const sheet = NVEditOptions.querySelector('.nvEditOptionsCon1');
    const handle = NVEditOptions.querySelector('#NVEditOptionsHideBar');

    if (!sheet || !handle) return;

    // Prevent duplicate listener setup
    if (this.__nvEditOptionsDragInit) return;
    this.__nvEditOptionsDragInit = true;

    let startY = 0;
    let currentY = 0;
    let lastY = 0;
    let lastTime = 0;
    let dragging = false;
    let velocity = 0;

    const originalTransition =
      getComputedStyle(sheet).transition || 'transform 0.35s ease, opacity 0.35s ease';

    const startDrag = (e) => {
      if (NVEditOptions.style.display === 'none' || NVEditOptions.style.display === '') return;

      dragging = true;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      startY = clientY;
      currentY = clientY;
      lastY = clientY;
      lastTime = performance.now();

      sheet.style.transition = 'none';
      sheet.style.willChange = 'transform, opacity';
    };

    const onDrag = (e) => {
      if (!dragging) return;

      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      const diff = Math.max(0, clientY - startY);
      currentY = clientY;

      // velocity calculation
      const now = performance.now();
      const deltaTime = now - lastTime;
      velocity = (clientY - lastY) / deltaTime;
      lastY = clientY;
      lastTime = now;

      sheet.style.transform = `translateY(${diff}px)`;
      sheet.style.opacity = `${Math.max(0.3, 1 - diff / 300)}`;
    };

    const endDrag = () => {
      if (!dragging) return;
      dragging = false;
      sheet.style.transition = originalTransition;
      sheet.style.willChange = '';

      const diff = currentY - startY;
      const dismissThreshold = 120;
      const velocityThreshold = 0.6;

      if (diff > dismissThreshold || velocity > velocityThreshold) {
        // dismiss
        sheet.style.transform = 'translateY(100%)';
        sheet.style.opacity = '0';
        this._handelEditOptinsShow(false)
      } else {
        // snap back
        sheet.style.transform = 'translateY(0)';
        sheet.style.opacity = '1';
      }
    };

    // === Event Listeners ===
    const dragTargets = [sheet, handle, NVEditOptions];
    dragTargets.forEach((el) => {
      el.addEventListener('touchstart', startDrag, { passive: true });
      el.addEventListener('mousedown', (ev) => {
        ev.preventDefault();
        startDrag(ev);
      });
    });

    window.addEventListener('touchmove', onDrag, { passive: true });
    window.addEventListener('mousemove', onDrag);
    window.addEventListener('touchend', endDrag);
    window.addEventListener('mouseup', endDrag);

    // Close when tapping backdrop (outside sheet)
    NVEditOptions.addEventListener('click', (ev) => {
      // Only close if clicked outside the sheet
      if (ev.target === NVEditOptions) {
        this._handelEditOptinsShow(false);
      }
    });
  }



  async _editCurrentBusiness() {
    console.log('open edit');
    if (!this.#currentBusinessId) {
      alert('No podimos cargar tu empresa en este momento. Intenta de nuevo mas tarde.')
    }

    const businessData = await firebase._getAnyDocById(`businesses/${this.#currentBusinessId}`)
    if (!businessData) {
      alert('No podimos cargar tu empresa en este momento. Intenta de nuevo mas tarde.')
    }
    NVBusinessEditor._init(businessData, true)
  }
  _deleteCurrentBusiness() {
    alert('Eliminar un empresa no es posible en este momento. Pedimos de tu paciencia mientras estamos mejorando esta aplicación.')
  }

  _handelEditOptinsEvents() {
    const NVEditOptions = document.getElementById('NVEditOptions')
    const NVEditOptionsHideBar = document.getElementById('NVEditOptionsHideBar')
    const NVEditOptionsEdit = document.getElementById('NVEditOptionsEdit')
    const NVEditOptionsDelete = document.getElementById('NVEditOptionsDelete')

    NVEditOptions.addEventListener('click', () => {
      this._handelEditOptinsShow(false)
    })
    NVEditOptionsHideBar.addEventListener('click', () => {
      this._handelEditOptinsShow(false)
    })

    NVEditOptionsEdit.addEventListener('click', () => {
      this._editCurrentBusiness()
    })
    NVEditOptionsDelete.addEventListener('click', () => {
      this._deleteCurrentBusiness()
    })




  }

  async _selectActiDisplay(tab) {
    console.log(tab);
    const nvActiCon4 = document.getElementById('nvActiCon4')
    const allSelectors = nvActiCon4.querySelectorAll('.nvActiCon5')

    allSelectors.forEach(selector => {
      const isTab = selector.dataset.selector === tab
      if (!isTab) {
        selector.classList.remove('nvActiCon5Act')
        selector.querySelector('.nvActiText2').classList.remove('nvActiText2Act')
      } else {
        selector.classList.add('nvActiCon5Act')
        selector.querySelector('.nvActiText2').classList.add('nvActiText2Act')
      }
    });


    nvActiCon4.addEventListener('click', async (e) => {
      const isSelector = e.target.closest('.nvActiCon5')
      if (isSelector) {
        const selected = isSelector.dataset.selector

        if (selected !== 'sellerprofile') {
          allSelectors.forEach(selector => {
            selector.classList.remove('nvActiCon5Act')
            selector.querySelector('.nvActiText2').classList.remove('nvActiText2Act')

          });
          isSelector.classList.add('nvActiCon5Act')
          isSelector.querySelector('.nvActiText2').classList.add('nvActiText2Act')
        }


        if (selected === 'listing-drafts') {
          this._NVDisplayListignDrafts()
        }
        if (selected === 'businesses') {
          this._NVDipslayBusinesses()
        }
        if (selected === 'listings') {
          this._NVDisplayListings()
        }
        if (selected === 'more') {
          this._NVDisplayMore()
        }
        if (selected === 'history') {
          const userSavedHistory = await GENRALHELPERS._getUserHistory()
          console.log(userSavedHistory)
          this._NVDisplayHistory()
        }
        if (selected === 'sellerprofile') {
          this._NVSellerProfile()
        }
      }

    })

  }
  async _NVDisplayListignDrafts(reset = false) {
    if (reset) {
      // this.#draftsEventsActivated = false
    }
    this.#currentActi = "listing-drafts"
    const nvActiCon8ItemsMainCon = document.getElementById('MainAppConWithNavigationContentConBusiness')
    const nvActiCon8Items = document.getElementById('nvActiCon8Items')
    nvActiCon8Items.innerHTML = ""
    const drafts = await createListing._getDrafts()
    drafts.forEach(draft => {
      const currentTime = Date.now();
      if (draft.uploadStatus === 'uploading' && currentTime - draft.savedAt > 60000) {
        createListing._deleteDraft(draft.prefixId)
        return
      }
      const html = GenerateHtml._actiListingDraft(draft)
      nvActiCon8Items.insertAdjacentHTML("beforeend", html);
    })


    if (this.#draftsEventsActivated) return
    this.#draftsEventsActivated = true

    nvActiCon8ItemsMainCon.addEventListener('click', async (e) => {
      const isDraft = e.target.closest('.actiListingDraftCon1A')
      const isDeleteBtn = e.target.closest('.actiListingDraftCon15')
      const isUseBtn = e.target.closest('.actiListingDraftCon16')
      console.log('Yep clicked', isDraft, isDeleteBtn, isUseBtn);

      if (!isDraft) return
      const id = isDraft.dataset.id

      if (!id) return

      if (isUseBtn) {
        console.log('used');
        createListing._init(null, id)
      }
      if (isDeleteBtn) {
        const result = await createListing._deleteDraft(id)
        console.log(result);
        if (result === 'deleted') {
          isDraft.remove()
        }
      }
    })


  }



  async _handleUploadButtons() {
    if (this.#windowEventActivated) return
    this.#windowEventActivated = true
    window.addEventListener('click', async (e) => {
      const isUploadButton = e.target.closest('.actiUploadButton')
      if (isUploadButton) {
        const openTo = isUploadButton.dataset.opento
        if (openTo === 'uploadGeneral') {
          console.log('here');
          createListing._init()
        }
        if (openTo === 'uploadListing') {
          console.log('here');
          createListing._init()
        }
        if (openTo === 'createBusiness') {
          console.log('here');
          NVBusinessEditor._init()
        }

      }

      const isBusinessEditOptionsButton = e.target.closest('.onBusinessOpenEditOptions')
      if (isBusinessEditOptionsButton) {
        const businessId = isBusinessEditOptionsButton.closest('.v20BusinessCon1A').dataset.businessid
        if (businessId) {
          this.#currentBusinessId = businessId
          this._handelEditOptinsShow(true)
        }
      }
    })
  }


  _NVPreparePage(tab) {
    const mainCon = document.getElementById('MainAppConWithNavigationContentConBusiness')
    mainCon.style.display = 'flex'

    mainCon.innerHTML = GenerateHtml._NVActiPageHtml()

    if (tab === 'listing-drafts') {
      this._NVDisplayListignDrafts(true)
    } else {
      this._NVDipslayBusinesses()
    }


  }

  async _NVDisplayListings() {
    try {
      spinner._displaySpinner('Cargando tus listdos')
      this.#currentActi = "listings"
      const nvActiCon8Items = document.getElementById('nvActiCon8Items')
      nvActiCon8Items.innerHTML = ""
      const userData = firebase._getLatestCurrentUserData();
      if (this.#currentActi !== 'listings') return
      console.log(userData);
      if (!userData) {
        // throw new Error("No hemos podido cargar tu cuenta en este momento. Intente de nuevo mas al rato.")
        signUpProfile._open()
        return
      }
      if (this.#currentActi !== 'listings') return

      const loadedListings = await firebase._getAllDocsFromPathByMostRecent(`accounts/${userData.userId}/listings`, true)
      console.log(loadedListings, userData.userId)
      if (!loadedListings) {
        throw new Error("No hemos podido cargar tus listados en este momento. Intenta de nuevo mas tarde.")
      }
      if (this.#currentActi !== 'listings') return

      if (loadedListings.length > 0) {

        loadedListings.forEach((listing) => {
          const listingHtml = generateHtml._listingVerticalNV(listing, true, 'listing', false)
          nvActiCon8Items.insertAdjacentHTML("beforeend", listingHtml);
        })

      } else {
        const noListings = GenerateHtml._noActi('No tienes listados publicados en Mercado MAI.', 'Debes publicar un listado primero, luego lo encontrarás aquí.', 'Publicar un listado', 'uploadListing')
        if (this.#currentActi !== 'listings') return
        nvActiCon8Items.insertAdjacentHTML("beforeend", noListings);
      }
    } catch (error) {
      if (this.#currentActi !== 'listings') return
      alert(error.message)

    } finally {
      spinner._hideSpinner()
    }
  }

  async _NVDisplayMore() {
    this.#currentActi = "more"
    const nvActiCon8Items = document.getElementById('nvActiCon8Items')
    nvActiCon8Items.innerHTML = ""
    const noMore = GenerateHtml._noActi('Por el momento no hay mas publicaciones.', 'Porfavor tenganos un poquito paciencia mientras estamos desarollando mas tipos de publicaciónes en Mercado MAI.', 'Publicar', 'uploadGeneral')
    nvActiCon8Items.insertAdjacentHTML("beforeend", noMore);
  }


  async _NVDisplayHistory() {
    this.#currentActi = "history"
    const nvActiCon8Items = document.getElementById('nvActiCon8Items')
    nvActiCon8Items.innerHTML = ""
    const noMore = GenerateHtml._noActi('Esta función está en desarollo.', 'Por favor tenos un poco de paciencia mientras mejoramos tu experiancia.', null, null)
    nvActiCon8Items.insertAdjacentHTML("beforeend", noMore);
  }



  async _NVSellerProfile() {
    console.log('seller profile');

    const userData = firebase._getLatestCurrentUserData();
    if (!userData) {


      signUpProfile._open()
      return

      // throw new Error("No hemos podido cargar tu cuenta en este momento. Intente de nuevo mas al rato.")
    }

    allHandeling._displaySellerEach(userData.userId)
  }


  async _NVDipslayBusinesses() {
    try {
      spinner._displaySpinner('Cargando tus empresas.')


      this.#currentActi = "businesses"
      const nvActiCon8Items = document.getElementById('nvActiCon8Items')
      nvActiCon8Items.innerHTML = ""
      await firebase._getUserDataFromBase()
      const userData = firebase._getLatestCurrentUserData();
      if (!userData) {


        signUpProfile._open()
        return

        // throw new Error("No hemos podido cargar tu cuenta en este momento. Intente de nuevo mas al rato.")
      }

      console.log(userData);
      console.log(userData.businesses);

      // if (0 > 0) {
      if (userData?.businesses?.length > 0) {
        for (const business of userData.businesses) {
          if (this.#currentActi !== 'businesses') return

          const loadedBusinessData = await firebase._getAnyDocById(`businesses/${business.id}`)
          if (!loadedBusinessData) {
            alert(`Esta empresa ya no existe o fue eliminado.\n\nID: ${business.id}\n\nPorfavor ponte en contacto con nuestro equipo de soporte para resolver este error.`);
            continue; // 👈 skip this business and move on
          }
          if (this.#currentActi !== 'businesses') return
          const { listings, lastVisibleDoc } =
            await firebase._getRecentListingsWithFilter(
              null,
              6,
              `businesses/${business.id}/listings`
            );

          let listingsHtml = ``;
          if (this.#currentActi !== 'businesses') return
          if (!listings || listings.length === 0) {
            listingsHtml +=
              generateHtmlListings._listingVerticalMiniNoListings();
          } else {
            if (this.#currentActi !== 'businesses') return
            for (const listing of listings) {
              if (this.#currentActi !== 'businesses') return
              listingsHtml +=
                await generateHtmlListings._listingVerticalMini(
                  listing,
                  null,
                  "listingInBusiness",
                  business.businessId
                );
            }
            // listingsHtml += generateHtmlListings._viewAllListingsMini(
            //   business.colors
            // );
          }

          if (this.#currentActi !== 'businesses') return
          const businessInPackHtml =
            await generateHtmlListings._generateBusiness2v(
              listingsHtml,
              loadedBusinessData, null, null, true, true
            );
          if (this.#currentActi !== 'businesses') return
          nvActiCon8Items.insertAdjacentHTML("beforeend", businessInPackHtml);
          spinner._hideSpinner()

        }



        // Should be removed for PROD
        // const noBusinessesHtml = GenerateHtml._noActi('No tienes un negocio en Mercado MAI.', 'Debes crear un negocio primero, luego lo podrás encontrar aquí.', 'Crear un negocio', 'createBusiness')
        // nvActiCon8Items.insertAdjacentHTML("beforeend", noBusinessesHtml);

      } else {
        if (this.#currentActi !== 'businesses') return

        const noBusinessesHtml = GenerateHtml._noActi('No tienes una empresa en Mercado MAI.', 'Debes crear una empresa primero, luego lo podrás encontrar aquí.', 'Crear una Empresa', 'createBusiness')
        nvActiCon8Items.insertAdjacentHTML("beforeend", noBusinessesHtml);

      }
    } catch (error) {
      if (this.#currentActi !== 'businesses') return
      alert(error.message)
    } finally {
      spinner._hideSpinner()
    }
  }



  async _checkForBusiness() {
    const bussinessDisplayHeaderCon10ForBusinessOwn = document.getElementById(
      "bussinessDisplayHeaderCon10ForBusinessOwn"
    );

    this.#currentAccount = firebase._getLatestCurrentUserData();
    console.log(this.#currentAccount);

    if (this.#currentAccount && this.#currentAccount?.business) {
      const business = await firebase._getBusinessById(
        this.#currentAccount.business
      );

      this.#currentBsiness = business;

      const listings = await firebase._getAllDocsFromPathByMostRecent(
        `businesses/${this.#currentAccount.business}/listings`,
        true
      );
      console.log(listings);

      bussinessDisplayHeaderCon10ForBusinessOwn.innerHTML =
        await GenerateHtml._business(business);
      this._fillInBusinessListings(listings, business);

      this._eventsHasPage();
      this._generalEvents();
    } else {
      bussinessDisplayHeaderCon10ForBusinessOwn.innerHTML =
        GenerateHtml._createBusinessPageMessage(this.#currentAccount);
      bussinessDisplayHeaderCon10ForBusinessOwn.insertAdjacentHTML(
        "beforeend",
        GenerateHtml._createBusinessPageButtons(this.#currentAccount)
      );
      GENRALHELPERS._animateCTA("OwnBusinessConButtonCreateBusinessPage");
      this._eventsNoPage();
      this._generalEvents();
    }
  }

  async _handelActionsOnBusiness(id, button) {
    console.log(id);
    // OwnBusinessCon3

    if (id === "OwnBusinessButtonsActionOnBusinessEdit") {
      spinner._displaySpinner()
      const businessData = await firebase._getAnyDocById(`businesses/${this.#currentBsiness.businessId}`)

      if (businessData) {
        NVBusinessEditor._init(businessData, true)
      } else {
        alert('No hemos podido cargar tu empresa en este momento. Intente de nuevo mas tarde.')
      }
      // businessPageEditor._init("edit");
    }

    OwnBusinessButtonsActionOnBusinessStats ||
      OwnBusinessButtonsActionOnBusinessBoost ||
      OwnBusinessButtonsActionOnBusinessShare;

    if (
      id === "OwnBusinessButtonsActionOnBusinessStats" ||
      id === "OwnBusinessButtonsActionOnBusinessBoost" ||
      id === "OwnBusinessButtonsActionOnBusinessActionMenu"
    ) {
      alert("Próximamente. Esta función aún no esta lista.");
    }
    if (
      id === "OwnBusinessConButtonEditBusinessPageLists1" ||
      id === "OwnBusinessConButtonEditBusinessPageLists2"
    ) {
      businessPageEditor._init("edit", "lists");
      console.log("yep here");
    }
    if (
      id === "OwnBusinessButtonsActionOnBusinessShare" ||
      id === "OwnBusinessButtonsActionOnBusinessOpen"
    ) {
      const businessId = button.closest(".OwnBusinessCon3").dataset.businessid;

      if (businessId) {
        if (id === "OwnBusinessButtonsActionOnBusinessShare") {
          allHandeling._displayTheRightWay(
            businessId,
            null,
            "business",
            null,
            true
          );
        } else {
          allHandeling._displayTheRightWay(businessId, null, "business");
        }
      } else {
        alert(
          "Hubio un error al abrir tu empresa. \n Si este error persiste, sugerijmos que cierras y luego abres esta aplicación de nuevo."
        );
      }
    }
  }

  async _displayLists(listName) {
    let htmlToReturn;
    const htmlContainerId = GENRALHELPERS._getUniqueIdfunction();

    try {
      htmlToReturn = GenerateHtml._listingsCon(listName, htmlContainerId);
      return [htmlToReturn, htmlContainerId];
    } catch (err) {
      if (err.name === "AbortError") {
        console.log("Display For You aborted.");
      } else {
        console.error(err);
      }
    }
  }

  async _fillInBusinessListings(listings, businessData) {
    console.warn(listings);
    const fillInListings = async () => {
      const OwnBusinessConBusinessListingsCon = document.getElementById(
        "OwnBusinessConBusinessListingsCon"
      );
      for (const listing of listings) {
        // if (signal.aborted) throw new Error("Aborted");
        const html = await displayListing._listingVertical(
          listing,
          businessData.colors,
          null,
          businessData.businessId,
          undefined,
          "false",
          true
        );
        OwnBusinessConBusinessListingsCon.insertAdjacentHTML("beforeend", html);
      }
    };
    fillInListings();
  }
  _eventsNoPage() {
    const createPageButton = document.getElementById(
      "OwnBusinessConButtonCreateBusinessPage"
    );
    // const buttonLogin = document.getElementById("OwnBusinessConButtonLogin");
    // buttonLogin.addEventListener("click", () => {
    //   register._displayOptions("create_business_page");
    // });
    createPageButton.addEventListener("click", () => {
      const account = firebase._getLatestCurrentUserData();
      if (account) {
        if (!account.whatsAppNumber) {
          accountProfileChange._open();
          alert(
            "Debes tener un perfil de vendedor para poder publicar listados."
          );
          return;
        }
        businessPageEditor._init();
      } else {
        register._displayOptions("create_business_page");
      }
    });
  }

  _showTopBusinessCon() {
    const bussinessDisplayHeaderCon10ForBusinessOwn = document.getElementById(
      "bussinessDisplayHeaderCon10ForBusinessOwn"
    );
    bussinessDisplayHeaderCon10ForBusinessOwn.classList.remove(
      "OwnBusinessConBusinessMessageConColapsed"
    );
  }
  _hideTopBusinessCon() {
    const bussinessDisplayHeaderCon10ForBusinessOwn = document.getElementById(
      "bussinessDisplayHeaderCon10ForBusinessOwn"
    );
    bussinessDisplayHeaderCon10ForBusinessOwn.classList.add(
      "OwnBusinessConBusinessMessageConColapsed"
    );
  }

  _scrollDirectionDecide(direction) {
    if (direction === "up") {
      this._showTopBusinessCon();
    } else if (direction === "down") {
      this._hideTopBusinessCon();
    }
  }

  _detectScrollDirection(id, callback) {
    const container = document.getElementById(id);
    let lastScrollTop = container.scrollTop;

    container.addEventListener("scroll", () => {
      const currentScrollTop = container.scrollTop;
      const diff = currentScrollTop - lastScrollTop;

      if (currentScrollTop < 0) return;

      // Check if the container is scrolled to the bottom
      if (
        container.scrollHeight - container.scrollTop ===
        container.clientHeight
      ) {
        this._showTopBusinessCon(); // Call when at the bottom
      }

      if (Math.abs(diff) > 100) {
        const direction = diff > 0 ? "down" : "up";
        this._scrollDirectionDecide(direction);
        lastScrollTop = currentScrollTop; // reset after trigger
      }
    });
  }

  _addTheRightPaddingToItemsCon() {
    const con = document.getElementById(
      "bussinessDisplayHeaderCon10ForBusinessOwn"
    ); // Replace with your actual ID or class
    const target = document.getElementById("OwnBusinessConBusinessListingsCon");

    console.log(con, target);

    if (con && target) {
      const conHeight = con.offsetHeight;
      console.log(conHeight);
      target.style.paddingTop = `${conHeight + 5}px`;
    }
  }

  _eventsHasPage() {
    this._detectScrollDirection("OwnBusinessConBusinessListingsCon");
    this._addTheRightPaddingToItemsCon();
    const buttonsContainer = document.querySelectorAll(
      ".OwnBusinessButtonsActionOnBusinessForEventListining"
    );
    buttonsContainer.forEach((button) => {
      button.addEventListener("click", (e) => {
        // Check for the closest element with an ID
        const targetButton = e.target.closest(
          ".OwnBusinessButtonsActionOnBusinessForEventListining"
        );
        if (targetButton && targetButton.id) {
          this._handelActionsOnBusiness(targetButton.id, button);
        } else {
          console.log("No valid ID found.");
        }
      });
    });
  }

  async _openSubscription(dataIn) {
    let dataToSend = null;
    if (this.#currentBsiness?.currentSubscriptionId) {
      dataToSend = await firebase._getAnyDocById(
        `subscriptions/${this.#currentBsiness.currentSubscriptionId}`
      );
    }

    const subscriptionPlanTextHeader = document.querySelectorAll(
      ".subscriptionPlanTextHeader"
    );
    const subscriptionPlanExitButtons = document.querySelectorAll(
      ".subscriptionPlanExitButtons"
    );
    const subscriptionPlanNextButtons = document.querySelectorAll(
      ".subscriptionPlanNextButtons"
    );
    const subscriptionPlanSelectYearButton = document.getElementById(
      "subscriptionPlanSelectYearButton"
    );
    const subscriptionPlanSelectMonthButton = document.getElementById(
      "subscriptionPlanSelectMonthButton"
    );
    const subscriptionPlanConMonth = document.getElementById(
      "subscriptionPlanConMonth"
    );
    const subscriptionPlanConYear = document.getElementById(
      "subscriptionPlanConYear"
    );
    const subscriptionPlanInputPriorityPointsMonth = document.getElementById(
      "subscriptionPlanInputPriorityPointsMonth"
    );
    const subscriptionPlanInputPriorityPointsYear = document.getElementById(
      "subscriptionPlanInputPriorityPointsYear"
    );
    const subscriptionPlanFinalPriceMonth = document.getElementById(
      "subscriptionPlanFinalPriceMonth"
    );
    const subscriptionPlanFinalPriceYear = document.getElementById(
      "subscriptionPlanFinalPriceYear"
    );

    const subscriptionPlanSelectListingsMonth = document.getElementById(
      "subscriptionPlanSelectListingsMonth"
    );
    const allLisitngSelectorsInMonth =
      subscriptionPlanSelectListingsMonth.querySelectorAll(".SubBusPlanCon12");

    const subscriptionPlanSelectListingsYear = document.getElementById(
      "subscriptionPlanSelectListingsYear"
    );
    const allLisitngSelectorsInYear =
      subscriptionPlanSelectListingsYear.querySelectorAll(".SubBusPlanCon12");

    let subscriptionDataToSet = null;
    let planselected = "month";
    let listingSelected = "included";
    let priorityLevelSelected = "";
    subscriptionPlanTextHeader.textContent =
      "Escoge el plan perfecto para tu empresa";

    if (dataIn) {
      dataIn.items.forEach((item) => {
        if (item.type === "subscripción") {
          subscriptionDataToSet = item;
        }
      });
    }

    if (subscriptionDataToSet) {
      subscriptionPlanTextHeader.textContent = "Renueva tu plan";
      planselected = subscriptionDataToSet.plan;
      listingSelected = subscriptionDataToSet.listings;
      priorityLevelSelected = subscriptionDataToSet.priorityLevel;
    }

    const allowOnlyNumbers = (event) => {
      const input = event.target;
      const value = input.value;

      // Replace all non-digit characters
      input.value = value.replace(/\D/g, ""); // \D matches any non-digit character
    };

    const calculatePlanPrice = (data) => {
      let finalAmount = 0;

      if (data.plan === "month") {
        finalAmount += 290;
      }
      if (data.plan === "year") {
        finalAmount += 2958;
      }
      if (data.listings === "20") {
        finalAmount += 290;
      }
      if (data.listings === "30") {
        finalAmount += 480;
      }
      if (data.listings === "45") {
        finalAmount += 600;
      }
      if (data.listings === "240") {
        finalAmount += 2958;
      }
      if (data.listings === "360") {
        finalAmount += 4896;
      }
      if (data.listings === "540") {
        finalAmount += 5508;
      }
      if (data.plan === "month" && data.listings === "unlimited") {
        finalAmount += 1280;
      }
      if (data.plan === "year" && data.listings === "unlimited") {
        finalAmount += 13056;
      }

      finalAmount += Number(data.priorityLevel * 0.5);

      if (data.plan === "month") {
        console.log("month now");
        subscriptionPlanFinalPriceMonth.textContent = `$${GENRALHELPERS._formatToPrice(
          finalAmount
        )}`;
      }
      if (data.plan === "year") {
        console.log("yearNow");
        subscriptionPlanFinalPriceYear.textContent = `$${GENRALHELPERS._formatToPrice(
          finalAmount
        )}`;
      }
    };

    const getPlanData = () => {
      const planData = {
        plan: "",
        listings: "",
        priorityLevel: "",
      };
      console.log(planselected);
      if (planselected === "month") {
        allLisitngSelectorsInMonth.forEach((selector) => {
          if (selector.dataset.selected === "true") {
            planData.listings = selector.dataset.numberoflistings;
          }
        });

        planData.priorityLevel =
          subscriptionPlanInputPriorityPointsMonth.value.trim();
        if (planData.priorityLevel === "") {
          planData.priorityLevel = "0";
        }
        planData.plan = "month";
      }
      if (planselected === "year") {
        allLisitngSelectorsInYear.forEach((selector) => {
          if (selector.dataset.selected === "true") {
            planData.listings = selector.dataset.numberoflistings;
          }
        });

        planData.priorityLevel =
          subscriptionPlanInputPriorityPointsYear.value.trim();

        if (planData.priorityLevel === "") {
          planData.priorityLevel = "0";
        }
        planData.plan = "year";
      }
      calculatePlanPrice(planData);
      console.log(planData);
      return planData;
    };

    subscriptionPlanInputPriorityPointsMonth.addEventListener("blur", (e) => {
      allowOnlyNumbers(e);
      getPlanData();
    });
    subscriptionPlanInputPriorityPointsMonth.addEventListener("keyup", (e) => {
      allowOnlyNumbers(e);
      getPlanData();
    });
    subscriptionPlanInputPriorityPointsYear.addEventListener("blur", (e) => {
      allowOnlyNumbers(e);
      getPlanData();
    });
    subscriptionPlanInputPriorityPointsYear.addEventListener("keyup", (e) => {
      allowOnlyNumbers(e);
      getPlanData();
    });

    const setYearListingSelector = (closestSelector) => {
      console.log(closestSelector);
      allLisitngSelectorsInYear.forEach((selector) => {
        const text = selector.querySelector(".SubBusPlanCon12Text");
        selector.classList.remove("SubBusPlanCon12ActivePro");
        selector.classList.add("SubBusPlanCon12NoneActive");
        text.classList.remove("SubBusPlanConText8");
        text.classList.add("SubBusPlanConText10B");
        selector.dataset.selected = "false";
        if (
          selector.dataset.numberoflistings ===
          closestSelector.dataset.numberoflistings
        ) {
          selector.dataset.selected = "true";
          text.classList.add("SubBusPlanConText8");
          text.classList.remove("SubBusPlanConText10B");
          console.log(selector.dataset.numberoflistings);
          selector.classList.add("SubBusPlanCon12ActivePro");
          selector.classList.remove("SubBusPlanCon12NoneActive");
        }
      });
      getPlanData();
    };
    const setMonthListingSelector = (closestSelector) => {
      console.log(closestSelector);
      allLisitngSelectorsInMonth.forEach((selector) => {
        const text = selector.querySelector(".SubBusPlanCon12Text");
        selector.classList.remove("SubBusPlanCon12Active");
        selector.classList.add("SubBusPlanCon12NoneActive");
        text.classList.remove("SubBusPlanConText8");
        text.classList.add("SubBusPlanConText10");
        selector.dataset.selected = "false";
        if (
          selector.dataset.numberoflistings ===
          closestSelector.dataset.numberoflistings
        ) {
          selector.dataset.selected = "true";
          text.classList.add("SubBusPlanConText8");
          text.classList.remove("SubBusPlanConText10");
          console.log(selector.dataset.numberoflistings);
          selector.classList.add("SubBusPlanCon12Active");
          selector.classList.remove("SubBusPlanCon12NoneActive");
        }
      });
      getPlanData();
    };

    if (planselected === "month" && subscriptionDataToSet) {
      allLisitngSelectorsInMonth.forEach((selector) => {
        if (selector.dataset.numberoflistings === listingSelected) {
          setMonthListingSelector(selector);
        }
      });
      subscriptionPlanConMonth.style.display = "";
      subscriptionPlanConYear.style.display = "none";
      planselected = "month";
      subscriptionPlanInputPriorityPointsMonth.value = priorityLevelSelected;
    }
    if (planselected === "year" && subscriptionDataToSet) {
      allLisitngSelectorsInYear.forEach((selector) => {
        if (selector.dataset.numberoflistings === listingSelected) {
          setYearListingSelector(selector);
        }
      });
      subscriptionPlanConMonth.style.display = "none";
      subscriptionPlanConYear.style.display = "";
      planselected = "month";
      subscriptionPlanInputPriorityPointsYear.value = priorityLevelSelected;
    }

    subscriptionPlanSelectListingsMonth.addEventListener("click", (e) => {
      const closestSelector = e.target.closest(".SubBusPlanCon12");
      if (closestSelector) {
        setMonthListingSelector(closestSelector);
      }
    });
    subscriptionPlanSelectListingsYear.addEventListener("click", (e) => {
      const closestSelector = e.target.closest(".SubBusPlanCon12");
      if (closestSelector) {
        setYearListingSelector(closestSelector);
      }
    });

    subscriptionPlanSelectYearButton.addEventListener("click", () => {
      subscriptionPlanConMonth.style.display = "none";
      subscriptionPlanConYear.style.display = "";
      planselected = "year";
    });

    subscriptionPlanSelectMonthButton.addEventListener("click", () => {
      subscriptionPlanConMonth.style.display = "";
      subscriptionPlanConYear.style.display = "none";
      planselected = "month";
    });

    subscriptionPlanExitButtons.forEach((button) => {
      button.addEventListener("click", () => {
      });
    });
    subscriptionPlanNextButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const plan = getPlanData();
        console.log(plan);
      });
    });
  }
  _generalEvents() {
    const OwnBusinessButtonCreateListing = document.getElementById(
      "OwnBusinessButtonCreateListing"
    );
    const OwnBusinessConBusinessMessageConSubscriptionButton =
      document.getElementById(
        "OwnBusinessConBusinessMessageConSubscriptionButton"
      );
    OwnBusinessButtonCreateListing.addEventListener("click", () => {
      createListing._init();
    });

    if (OwnBusinessConBusinessMessageConSubscriptionButton) {
      OwnBusinessConBusinessMessageConSubscriptionButton.addEventListener(
        "click",
        () => {
          this._openSubscription();
        }
      );
    }
  }
}

export default new BusinessOwn();
